import {useEffect, useState} from 'react'
import {isMobile} from "react-device-detect";

import {useLocation, useNavigate, useLoaderData, useNavigation} from "react-router-dom";
// import { NavLink as RouterLink } from "react-router-dom";
// import {debounce} from 'lodash'; // cloneDeep, sortBy
import DOMPurify from "dompurify"

import {restorePath, normalizeRoute} from 'ultra/helpers/route'; // getParentPath

import {isEmptyObj} from 'ultra/helpers/utils';
import {getClientCity} from 'ultra/configs/general';
import {DEFAULT_CITY} from 'ultra/const/general';
import {getClientCityTimezone} from 'ultra/configs/general';
import {timestampToDate, getFormatedTime} from 'ultra/helpers/date'

import Backdrop from '@mui/material/Backdrop';
import TextField from '@mui/material/TextField';
import CancelIcon from '@mui/icons-material/Cancel';
import Slide from '@mui/material/Slide';
import SearchIcon from '@mui/icons-material/Search';

import {useConfigStore} from '../../Stores/config';
import NodeImage from '../../Modules/Content/Widgets/NodeImage';
import ContentImage from '../../Modules/Content/Widgets/ContentImage';
import FilterChip from '../../Modules/Content/Widgets/FilterChip'
import MessengerValue from '../../Modules/Content/Widgets/MessengerValue'
import URLValue from '../../Modules/Content/Widgets/URLValue'

import Preloader from '../../Components/Preloaders/Preloader';

import {NODE_ACTIONS} from '../../Modules/Content/Reducers/node';

import {useGlobalCustomContext} from '../../Helpers/context';
import {searchNode} from '../../Helpers/search';
import {getNodeContent} from '../../Helpers/content';

import './index.scss';

export default function GlobalSearch(props) {
    const {collapsable} = props;

    const {nodeState, nodeDispatch} = useGlobalCustomContext();

    const closeSearchResults = () => {
        nodeDispatch({type: NODE_ACTIONS.GLOBAL_SEARCH_TOGGLE, data: false});
    }

    return <>
        {collapsable && <Slide direction="left" in={nodeState.globalSearchVisible} mountOnEnter unmountOnExit>
            <div className="SearchWrap"><Search autoFocus={true}/></div>
        </Slide>}

        {!collapsable && <div className="SearchWrap"><Search /></div>}

        <Backdrop
            onClick={() => {closeSearchResults()}}
            sx={{zIndex: (theme) => theme.zIndex.modal + 1}}
            open={nodeState.globalSearchVisible}
        ></Backdrop>
    </>
}

function Search(props) {
    const {autoFocus} = props;
    
    const location = useLocation();
    const navigation = useNavigation();

    const {nodeState, nodeDispatch} = useGlobalCustomContext();

    const loaderPageConfig = useLoaderData();
    const [pageConfig, setPageConfig] = useState(loaderPageConfig);

    const [searchTimeout, setSearchTimeout] = useState(undefined);
    const [requestInProgress, setRequestInProgress] = useState(false);
    const [searchResult, setSearchResult] = useState([]);
    const [pageSearchResult, setPageSearchResult] = useState([]);

    const [searchQuery, setSearchQuery] = useState("");

    const city = getClientCity(window) || DEFAULT_CITY;

    useEffect(() => {
        if (!nodeState.globalSearchVisible) {
            removeSearchResult();
        }
    }, [nodeState.globalSearchVisible])

    useEffect(() => {
        if (nodeState.updatePageContentStart) {
            nodeDispatch({type: NODE_ACTIONS.UPDATE_PAGE_CONTENT_END});

            const notAuthorizedUserUpdates = {...nodeState.updatePageContentStartNotAuthorized}

            if (!isEmptyObj(notAuthorizedUserUpdates)) {
                if (!pageConfig.children.order.includes(notAuthorizedUserUpdates._uri)) {
                    pageConfig.children.order.push(notAuthorizedUserUpdates._uri)
                }
                pageConfig.children.list[notAuthorizedUserUpdates._uri] = notAuthorizedUserUpdates.page
                setPageConfig({...pageConfig});
            }
            else {
                const path = {
                    city: city,
                    uri: normalizeRoute(location.pathname)
                };

                getNodeContent(path, location.search)
                    .promise
                    .then(result => {
                        const data = result

                        if (!isEmptyObj(notAuthorizedUserUpdates)) {
                            if (!data.children.order.includes(notAuthorizedUserUpdates._uri)) {
                                data.children.order.push(notAuthorizedUserUpdates._uri)
                            }
                            data.children.list[notAuthorizedUserUpdates._uri] = notAuthorizedUserUpdates.page
                        }

                        setPageConfig(data)
                    })
            }
        }
    }, [nodeState.updatePageContentStart])

    useEffect(() => {
        if (!isMobile) {
            const keyDownHandler = event => {
                if (event.key === 'Escape') {
                    event.preventDefault();

                    document.body.classList.remove('search')
                    closeSearchResults();
                }
            };

            document.addEventListener('keydown', keyDownHandler);

            return () => {
                document.removeEventListener('keydown', keyDownHandler);
            };
        }
    }, [])

    let controllers = []

    const removeSearchResult = () => {
        setSearchQuery("");
        setSearchResult([]);
        setPageSearchResult([]);
        document.body.classList.remove('search-results');
        document.body.classList.remove('search-focus');
        document.body.classList.remove('search');
    }

    const closeSearchResults = () => {
        // cleaneSearchResults();
        nodeDispatch({type: NODE_ACTIONS.GLOBAL_SEARCH_TOGGLE, data: false});
    }

    const openSearchResults = () => {
        // cleaneSearchResults();
        nodeDispatch({type: NODE_ACTIONS.GLOBAL_SEARCH_TOGGLE, data: true});
    }

    const onSearchTextChange = async (e) => {
        controllers.map(c => {c.abort()});
        setRequestInProgress(false)

        const value = e.target.value;
        setSearchQuery(value)

        if (searchTimeout) {
            clearTimeout(searchTimeout);
            setSearchTimeout(undefined);
        }
        
        if (value?.length >= 2) {
            const st = setTimeout(async () => {

                openSearchResults()
                setRequestInProgress(true)
                document.body.classList.add('search-results')

                const city = getClientCity(window) || DEFAULT_CITY;

                try {
                    const {promise, controller} = await searchNode(city, value)
                    controllers.push(controller)

                    const sortSearch = (a, b) => {
                        if (a.title.toLowerCase() === value.toLowerCase()) {
                            return -1
                        }
                        else if (a.title.toLowerCase().indexOf(value.toLowerCase() + ' ') === 0) {
                            return -1
                        }
                        else {
                            return 1
                        }
                    }

                    promise.then(result => {
                        // find on page:
                        const page = []
                        const global = []

                        result.map(node => {
                            if (restorePath(node._uri) === location.pathname) return;

                            let isNodeOnPage = false;

                            pageConfig.children.order.map(uri => {
                                if (pageConfig.children.list[uri]._did === node.id) {
                                    isNodeOnPage = true;
                                }
                            })

                            if (isNodeOnPage) {
                                // if (node.title.toLowerCase() === value.toLowerCase()) {
                                if (node.highlights.find(h => h.field === 'title')) {
                                    page.unshift(node)
                                }
                                else {
                                    page.push(node)
                                }
                            }
                            else {
                                if (node.highlights.find(h => h.field === 'title')) {
                                    global.unshift(node)
                                }
                                else {
                                    global.push(node)
                                }
                            }

                            page.sort(sortSearch)
                            global.sort(sortSearch)
                        });

                        setPageSearchResult(page);
                        setSearchResult(global);

                        setRequestInProgress(false);

                        // const list = filterContent(configs.content.nodes, children.list, config?.templateOptions?.searchBy, value)
                        // Object.keys(list).map(uri => {
                        //     if (config?.templateOptions?.searchIgnoreNodes) {
                        //         if (!config?.templateOptions?.searchIgnoreNodes?.includes(list[uri]._type)) {
                        //             page.push(list[uri])    
                        //         }
                        //     } else {
                        //         page.push(list[uri])
                        //     }
                        // })

                        // remove data from page into global:
                        // setSearchResult(result.filter(i => {
                        //     const isNodeOnPage = page.findIndex(node => node._did === i.id) > -1;
                        //     return !isNodeOnPage;
                        // }));
                    }).catch(e => {
                        console.error(e)
                    })
                }
                catch (e) {
                    console.error(e.message)
                    // showError({snackbarMessage: 'Помилка'})
                }

            }, 500)

            setSearchTimeout(st)
        }
    }

    const onFocus = () => {
        document.body.classList.add('search-focus')
    }

    const onBlur = () => {
        document.body.classList.remove('search-focus')
    }

    return <>
        <div className="SearchWrapContainer">
            <TextField
                fullWidth
                autoFocus={autoFocus}
                variant="outlined"
                value={searchQuery}
                // onChange={debounce(onSearchTextChange, 500)}
                onChange={onSearchTextChange}
                onFocus={onFocus}
                onBlur={onBlur}
                className='SearchWrapInput'
                placeholder='Пошук'
            />

            <SearchIcon className='SearchWrapIcon' />

            <span className="SearchWrapClose" onClick={closeSearchResults}>
                <CancelIcon />
            </span>
        </div>
        {(requestInProgress || pageSearchResult.length > 0 || searchResult.length > 0) && <div className='searchResultItemWrap'>
            {requestInProgress && <div className='searchResultPreloader'>
                <Preloader />
            </div>}

            {pageSearchResult.length > 0 && <>
                <div className='searchResultSectionTitle'>
                    <div className='searchResultSectionTitleLabel'>
                        {/* <span>Знайдено на поточній сторінці:</span> */}
                        <span>Поточна сторінка:</span>
                        <span className='label'>{pageSearchResult.length}</span>
                    </div>
                </div>
                <div className='searchResultSectionResult'>
                    {pageSearchResult?.map(node => <SearchResultNode className='searchResultItem' key={`search_page_${node._uri}`} node={node} closeSearchResults={closeSearchResults} parentConfig={pageConfig.page.config}/>)}
                </div>
            </>}

            {searchResult.length > 0 && <>
                <div className='searchResultSectionTitle'>
                    <div className='searchResultSectionTitleLabel'>
                        {/* <span>Знайдено на Балі | Простір:</span> */}
                        <span>Балі | Простір:</span>
                        <span className='label'>{searchResult.length}</span>
                    </div>
                </div>
                <div className='searchResultSectionResult'>
                    {searchResult?.map(node => <SearchResultNode className='searchResultItem' key={`search_global_${node._uri}`} node={node} closeSearchResults={closeSearchResults} />)}
                </div>
            </>}

            {!requestInProgress && searchQuery?.length >= 3 && !pageSearchResult.length && !searchResult.length && <div className='noResults'>Нічого не знайдено</div>}
        </div>}
    </>
}

function SearchResultNode(props) {
    const {className, node, closeSearchResults} = props;

    const {configs} = useConfigStore();
    const navigate = useNavigate();

    const searchResultHandler = (uri) => {
        navigate(restorePath(uri))
        setTimeout(() => {
            closeSearchResults();
        }, 500)
    }

    const goToPage = (path) => {
        closeSearchResults();
        navigate(path);
    }

    return <div className={className}>
        {/* fields={configs.content.nodes[node._type].fields || parentConfig.childrenOptions?.[node._type]?.fields} */}
        <div className='searchResultItemParent'>
            {node?.parentParent?.title && <>
                <span className='pseudoLink' onClick={() => goToPage(restorePath(node.parentParent.uri))}>
                    {node.parentParent.title}
                </span>
                <span>
                    &nbsp;/&nbsp;
                </span>
            </>}

            <span className='pseudoLink' onClick={() => goToPage(restorePath(node?.parent?.uri))}>
                {node?.parent?.title}
            </span>
        </div>
        <div className='searchResultItemTitle'>{node.title}</div>

        <div className='searchResultItemContent'>
            {(node.thumbnail || node.poster) && <NodeImage values={node} className='thumbnail'/>}

            <div className='content'>
                {node.banner && !node.thumbnail && !node.poster && <ContentImage src="banner" className="searchResultItemBanner" image={node.banner} />}

                {/* {node.short_description && <div className='shortDescription'>{node.short_description}</div>} */}

                {node.category && <div className='category'><FilterChip className="textOnly" value={node.category} config={configs.content.nodes[node._type]?.fields?.category} /></div>}

                {node.description && node.highlights?.filter(highlight => highlight?.field !== 'title')?.length === 0 && <div className='description'>{node.description.substring(1, 120)} {node.description.length > 120 && <>...</>}</div>}

                <SearchResultNodeRows node={node} />

                {node.highlights?.filter(highlight => highlight?.field !== 'title')?.length > 0 && <div className='searchResultItemHighlights'>
                    {node.highlights
                        ?.filter(highlight => highlight?.field !== 'title')
                        ?.map(highlight => highlight?.snippet && <div className='searchResultItemHighlight' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize('...' + highlight.snippet + '...')}} />)}
                </div>}

                <SearchResultNodeTags node={node} />

                {/* hasDetailsPageLink(node) */}
                {/* {!node.noChildLinks && <div className='searchResultItemLink'>
                    <span className="emulateButton small" onClick={() => {closeSearchResults(); searchResultHandler(node._uri)}}>Детальніше</span>
                </div>}
                {node.noChildLinks && <div className='searchResultItemLink'>
                    <span className="emulateButton small" onClick={() => {closeSearchResults(); searchResultHandler(getParentPath(node._uri))}}>Перейти до списку</span>
                </div>} */}
                <div className='searchResultItemLink'>
                    <span className="emulateButton small" onClick={() => {searchResultHandler(node._uri)}}>Детальніше</span>
                </div>
            </div>
        </div>
    </div>
}

function SearchResultNodeTags(props) {
    const {node} = props;

    let result = <></>

    const {configs} = useConfigStore();

    switch (node._type) {
        case 'book':
            if (node.genre?.length > 0) {
                result = <div className='searchResultItemTags'>
                    {node.genre && <div>
                        {node.genre.map(genre => <FilterChip  value={genre} config={configs.content.nodes['book'].fields.genre} />)}
                    </div>}
                </div>
            }
            break;
    }
    
    return result;
}

function SearchResultNodeRows(props) {
    const {node} = props;
    const {configs} = useConfigStore();

    const [timeZone, setTimeZone] = useState()

    useEffect(() => {
        const city = getClientCity(window) || DEFAULT_CITY;
        setTimeZone(getClientCityTimezone(configs, city));
    }, [configs])

    let result = <></>

    switch (node._type) {
        case 'recommendation':
            if (!node.region && !node.messenger && !node.url) {
                result = <></>
            }
            else {
                result = <div className='searchResultItemDetails recommendation'>
                    {/* {node.category && <div className='labelWrap'>
                        <div className="label">Категорія:</div>
                        <FilterChip className="textOnly" value={node.category} config={configs.content.nodes[node._type]?.fields?.category} />
                    </div>} */}

                    {node.region && <div className='labelWrap'>
                        <div className="label">Район:</div>
                        {node.region && <FilterChip className="textOnly" value={node.region} config={node?.parent?._config?.childrenOptions?.[node._type]?.fields?.region || configs.content.nodes[node._type]?.fields?.region} />}
                    </div>}
                    {node.messenger && <div className='labelWrap'>
                        <span className="label">Месенджер:</span>
                        <span className="labelValue">
                            <MessengerValue messenger={node.messenger} />
                        </span>
                    </div>}
                    {node.url && <div className='labelWrap'>
                        <span className="label">Посилання:</span>
                        <span className="labelValue">
                            <URLValue value={node.url} />
                        </span>
                    </div>}
                </div>
            }
            break;

        case 'book':
            result = <div className='searchResultItemDetails book'>
                {node.region && <div className='labelWrap region'>
                    <span className="label">Район:</span>
                    <span className="labelValue">
                        <FilterChip className="textOnly" value={node.region} config={node?.parent?._config?.childrenOptions?.[node._type]?.fields?.region || configs.content.nodes[node._type]?.fields?.region} />
                    </span>
                </div>}
                {node.author && <div className='labelWrap'>
                    <span className="label">Автор:</span>
                    <span className="labelValue">
                        {node.author.join(', ')}
                    </span>
                </div>}
            </div>
            break;

        case 'event':
        case 'travel':
        case 'retreat':
            result = <div className={`searchResultItemDetails ${node._type}`}>
                {node.date && <div className='labelWrap'>
                    <span className="label">Дата та час:</span>
                    <span className='labelValue'>
                        {getFormatedTime(timestampToDate(node.date), timeZone)}
                    </span>
                </div>}
            </div>
            break;

        case 'analogue':
            result = <div className='searchResultItemDetails analogue'>
                {node.analogue && <div className='labelWrap'>
                    <span className="label">Аналоги:</span>
                    <span className="labelValue">
                        {node.analogue.join(', ')}
                    </span>
                </div>}
                {node.active_substances && <div className='labelWrap'>
                    <span className="label">Діючі речовини:</span>
                    <span className="labelValue">
                        {node.active_substances.join(', ')}
                    </span>
                </div>}
                {node.international && <div className='labelWrap'>
                    <span className="label">Міжнародна назва:</span>
                    <span className="labelValue">
                        {node.international}
                    </span>
                </div>}
            </div>
            break;
    }

    return result;
}
